import { COUPON_SERVICE_APIS } from "@/api_framework/api_config";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";

import { ICouponServiceTypeResponse, ICouponServiceTypeResponseData } from "@/api_framework/api_modals/coupon";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import AxiosCurlirize from "axios-curlirize";

AxiosCurlirize(axios, () => {});

export const useCouponCouponAllowEdit = () => {
  const [allowCoupon, setAllowCoupon] = useState<ICouponServiceTypeResponseData[]>([]);

  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const configuration = useConfiguration();

  const execute = useCallback(async () => {
    try {
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
      await axios
        .get(COUPON_SERVICE_APIS?.ALLOWCOUPON?.baseURL, {
          headers: {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
          },
        })
        .then((res: AxiosResponse<ICouponServiceTypeResponse>) => {
          if (res.data.status) {
            setAllowCoupon(res.data.data);
            //
          } else {
            setAllowCoupon([]);
          }
        })
        .catch((e: AxiosError) => {
          sendCurl(e.config["curlCommand"]);
          if (e.code === "ERR_BAD_REQUEST") {
            setAllowCoupon([]);
            //   toast.error("Error while fetching List details");
          }
          if (e.status === 400) {
            setAllowCoupon([]);
            //   toast("Product records not found");
          }

          if (e.response.status === 500) {
            setAllowCoupon([]);
            toast.error("Server error 500");
          }
        });
    } catch (e: any) {
      toast.error("Server Error: " + e.message);
      setAllowCoupon([]);
    }
  }, [dispatch]);
  return { execute, allowCoupon };
};
